/**
 * Catálogo: equipos + láminas. Cargados una vez por sesión (no cambian).
 */
import { api } from "./client";

export interface Team {
  id: number;
  code: string;
  name: string;
  color: string;
  group: string | null;
  count: number;
}

export interface Sticker {
  id: number;
  num: string;
  team_id: number;
  name: string;
  role: string;
  position: number;
  is_shield: boolean;
  is_legendary: boolean;
  is_limited: boolean;
  is_coca_cola: boolean;
  shirt: number | null;
  color: string | null;
  image_url: string | null;
}

export async function fetchTeams(): Promise<Team[]> {
  return api<Team[]>("/catalog/teams");
}

export async function fetchStickers(): Promise<Sticker[]> {
  return api<Sticker[]>("/catalog/stickers");
}
